<!-- routify:options index=1 -->
<script lang="ts">
  import { setModalHash } from '../shared/modal-store';
  import FooterSection from '../components/home/footer-section.svelte';
  import IntersectionObserver from 'svelte-intersection-observer';
  import { onDestroy, onMount } from 'svelte';
  import { checkInitialHeaderColors, setHeaderColor } from '../shared/header-store';
  import AnimatedFlow from '../components/home/animated-flow.svelte';
  import { scrollTo, trackViewSection } from '../shared/utils';
  import WorkingTogether from '../components/home/working-together.svelte';
  import Video from '../components/home/video.svelte';

  let elementsGroupDownwards: HTMLElement[] = [];
  let elementsGroupUpwards: HTMLElement[] = [];
  let intersectingGroupUpwards: boolean[] = [];
  let intersectingGroupDownwards: boolean[] = [];
  let isObserverDirty: boolean = false;

  onMount(() => {
    scrollTo({ top: 0 });
  });

  onDestroy(() => {
    isObserverDirty = false;
    checkInitialHeaderColors();
  });

  function setModalComponent(app) {
    setModalHash(app);
  }

  function setHeaderTheme(theme: string, background: string) {
    if (!isObserverDirty) {
      isObserverDirty = true;
      return;
    }

    setHeaderColor(theme, background, '/index');
  }
</script>

<IntersectionObserver
  element={elementsGroupUpwards[0]}
  bind:intersecting={intersectingGroupUpwards[0]}
  on:intersect={() => {
    if (intersectingGroupUpwards[0] && !intersectingGroupDownwards[1]) {
      setHeaderTheme('black', 'gray');
    }
  }}>
  <IntersectionObserver
    element={elementsGroupDownwards[0]}
    bind:intersecting={intersectingGroupDownwards[0]}
    on:intersect={() => {
      if (intersectingGroupDownwards[0] && !intersectingGroupDownwards[1]) {
        setHeaderTheme('black', 'gray');
        trackViewSection('home-squares-section');
      }
    }}>
    <div class="c-animated-flow relative">
      <AnimatedFlow />
      <span class="absolute bottom-[76px]" bind:this={elementsGroupUpwards[0]} />
      <span class="absolute top-[calc(100vh-72px)]" bind:this={elementsGroupDownwards[0]} />
    </div>
  </IntersectionObserver>
</IntersectionObserver>

<div class="relative">
  <IntersectionObserver
    element={elementsGroupUpwards[1]}
    bind:intersecting={intersectingGroupUpwards[1]}
    on:intersect={() => {
    if (intersectingGroupUpwards[1] && !intersectingGroupDownwards[0]) {
        setHeaderTheme('white', 'blue');
      }
    }}>
    <IntersectionObserver
      threshold={0}
      element={elementsGroupDownwards[1]}
      bind:intersecting={intersectingGroupDownwards[1]}
      on:intersect={() => {
      if (intersectingGroupDownwards[1]) {
          setHeaderTheme('white', 'blue');
          trackViewSection('home-video-section');
        }
      }}>
        <Video />

        <span class="absolute bottom-[76px]" bind:this={elementsGroupUpwards[1]} />
        <span class="absolute top-[calc(100vh-72px)]" bind:this={elementsGroupDownwards[1]} />
    </IntersectionObserver>
  </IntersectionObserver>

  <IntersectionObserver
    threshold={0}
    element={elementsGroupDownwards[2]}
    bind:intersecting={intersectingGroupDownwards[2]}
    on:observe={() => {
      if (intersectingGroupDownwards[2]) {
        setHeaderTheme('white', 'blue');
        trackViewSection('home-working-together');
      }
    }}
  >
    <WorkingTogether bind:element={elementsGroupDownwards[2]} />
  </IntersectionObserver>

</div>

<IntersectionObserver
  threshold={0}
  element={elementsGroupDownwards[3]}
  bind:intersecting={intersectingGroupDownwards[3]}
  on:observe={() => {
    if (intersectingGroupDownwards[3]) {
      setHeaderTheme('white', 'blue');
      trackViewSection('home-footer-section');
    }
  }}
>
  <FooterSection bind:element={elementsGroupDownwards[3]} />
</IntersectionObserver>
